export function stringToTitleCase(str: string) {
  // If it's a single word, just capitalize first letter
  if (!/[\s_]/.test(str) && !/[A-Z]/.test(str.substring(1))) {
    return str.charAt(0).toUpperCase() + str.substring(1).toLowerCase();
  }

  // Detect if it's camelCase (has uppercase letters but no spaces or underscores)
  if (/[A-Z]/.test(str) && !/[\s_]/.test(str)) {
    // Insert a space before all capital letters
    str = str.replace(/([A-Z])/g, ' $1');
  }
  // Detect if it's snake_case (has underscores)
  else if (str.includes('_')) {
    // Replace underscores with spaces
    str = str.replace(/_/g, ' ');
  }

  // Apply title case to the result
  return str
    .trim()
    .replace(/\s+/g, ' ')
    .replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase());
}


